import Api from './rest/SpecAiJobApi';

export default new Api();
